import { Component, OnInit, ViewChild } from '@angular/core';
import { Nav } from 'ionic-angular';

import { AuthLocalService } from './core/util/auth-local.service';
import { MenuService } from './core/util/menu.service';

@Component({
  templateUrl: 'app.html'
})
export class MyApp implements OnInit {
  rootPage: string;

  @ViewChild(Nav) nav: Nav;

  constructor(private authLocalService: AuthLocalService,
              public menuService: MenuService) {

  }

  ngOnInit() {
    this.rootPage = AuthLocalService.isAuthorized(this.authLocalService.getCurrentRole()) ? 'MeasureListPage' : 'LoginPage';
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts